// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__2mABa","cardLink":"Card_cardLink__8MDud","linkedInLink":"Card_linkedInLink__7RiHj","linkedIn":"Card_linkedIn__WkQkW","headshot":"Card_headshot__TJ_Nf"};